'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'

export function PrintButton() {
  const { t } = useTranslation(['printButton'])

  const handlePrint = () => {
    pushToGtmDataLayer({
      event: 'gaEvent',
      eventCategory: 'fiche article / produit',
      eventAction: 'clic cta',
      eventLabel: 'imprimer',
    })
    window.print()
  }

  return (
    <Button
      isRound
      variant="tertiary"
      size="sm"
      onPress={handlePrint}
      iconLeft={<Icon.Printer />}
      className="embed:hidden"
    >
      {t('printButton:label')}
    </Button>
  )
}
